import React, { useState } from 'react';
import Button, { ButtonWrap } from '@hubins/components/Button';
import Modal from '@hubins/components/Modal';

const ShowRawResponse = ({ screening }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="wide flex align-end s-top-l">
        <Button icon="Common File Text by Streamlinehq" onClick={() => setIsOpen(true)}>Show raw response</Button>
      </div>
      <Modal open={isOpen} callback={setIsOpen} closeButton shouldCloseOnOverlayClick>
        <pre>{JSON.stringify(screening.result, null, 2)}</pre>
      </Modal>
    </>
  );
};

export default ShowRawResponse;